<div class="container mt-5">
  <div class="float-left">
    &copy;{{ year }}, CollegeDreams | All rights reserved
  </div>
</div>
